import React from 'react';
import ContentShareButtons from './ContentShareButtons';
import {
  formatDate,
  resolveContentKindLabel,
  shouldShowUpdatedDate,
} from '../helpers';

type ContentMetaProps = {
  created?: string | null;
  modified?: string | null;
  effective?: string | null;
  programTitle?: string;
  pageUrl: string;
  title: string;
  content?: any;
};

export default function ContentMeta({
  created,
  modified,
  effective,
  programTitle,
  pageUrl,
  title,
  content,
}: ContentMetaProps) {
  const published = effective || created;
  const formattedPublished = formatDate(published);
  const formattedUpdated = formatDate(modified);

  const showUpdated =
    !!modified && !!created && shouldShowUpdatedDate({ created, modified });

  const kindLabel = resolveContentKindLabel(content);

  return (
    <section
      className="content-view__meta"
      aria-labelledby="content-meta-title"
    >
      <div className="content-view__meta-inner">
        {formattedPublished ? (
          <p className="content-view__meta-created">
            Publicado em{' '}
            <time dateTime={published || undefined}>{formattedPublished}</time>
          </p>
        ) : null}

        {showUpdated && formattedUpdated ? (
          <p className="content-view__meta-updated">
            Atualizado em{' '}
            <time dateTime={modified || undefined}>{formattedUpdated}</time>
          </p>
        ) : null}

        {programTitle ? (
          <p className="content-view__meta-context">
            {kindLabel} do programa {programTitle}
          </p>
        ) : null}
      </div>

      <ContentShareButtons
        title={title}
        url={pageUrl}
        className="content-view__share--bottom"
      />
    </section>
  );
}
